import React, { useState, useContext, useEffect } from "react";
import "./index.css";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import patientAvatar from "./icons/avatar.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import PropTypes from "prop-types";
import editIcon2 from "./icons/edit2.png";
import deleteIcon from "./icons/delete.png";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import sadIcon from "./icons/sad2.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useUser from "../../context/user/useUser";
import { getToken, getUserId } from "../../auth/authenticate";
import DefaultTextInput from "components/common/DefaultTextInput/DefaultTextInput";
import ErrorDisplay from "components/common/ErrorDisplay/ErrorDisplay";
import EditableMultiSelect from "./components/EditableMultiSelect/EditableMultiSelect";
import EditableSelect from "./components/EditableSelect/EditableSelect";
import AddGuardianModal from "./components/AddGuardianModal/Index";
import { CircularProgress, useRadioGroup } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import IconButton from "@mui/material/IconButton";
import { ApiEndpoint } from "config/constants/apiConstants";
import {
  ChangeAcceptDetailModal,
  ChangeDetailModal,
  DeactivateModal,
  MorePatientModal,
} from "./components/Modals/Index";
import { EnterOTPModal } from "./components/Modals/OTPInput/OTPDialog";
import TimezoneSelect from "react-timezone-select";
import momentTz from 'moment-timezone';
import useDeedToast from "hook/useDeedToast";

const EditDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

EditDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

// add patient Modal
const AddPatientDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const AddPatientDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

AddPatientDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

// deactivate modal
const DeactivateDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const DeactivateDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

DeactivateDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const longTermMedicationsArr = ["Cough", "Fever", "Head Ache"];
const url = `${process.env.REACT_APP_BACKEND_URL}user/patient/profile/`;
const urlGuardian = `${process.env.REACT_APP_BACKEND_URL}user/patient/get-patients`;

const PatientProfile = (props) => {
  const districts = [
    "Colombo",
    "Gampaha",
    "Kalutara",
    "Kandy",
    "Matale",
    "Nuwara Eliya",
    "Galle",
    "Matara",
    "Hambantota",
    "Jaffna",
    "Kilinochchi",
    "Mannar",
    "Vavuniya",
    "Mullaitivu",
    "Batticaloa",
    "Ampara",
    "Trincomalee",
    "Kurunegala",
    "Puttalam",
    "Anuradhapura",
    "Polonnaruwa",
    "Badulla",
    "Moneragala",
    "Ratnapura",
    "Kegalle",
  ];

  // let userValue = useContext(UserContext);
  // let { user_id, user_type } = userValue;
  const { settings } = useUser();
  const user_id = settings.userId;
  const user_type = settings.userType;
  const navigate = useNavigate();
  // const [EditDialogOpen, setEditDialogOpen] = useState(false);
  const [addPatientDialogOpen, setAddPatientDialogOpen] = useState(false);
  const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);
  const [patientName, setPatientName] = useState();
  const [selectName, setSelectName] = useState([]);
  const [count, setCount] = useState(0);
  const [patientData, setPatientData] = useState([]);
  const [country, setCountry] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [medications, setMedications] = useState([]);
  const allergiesArr = ["Pollen", "Dust", "Pets"];

  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [district, setDistrict] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const [allergies, setAllergies] = useState([]);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isImgUploading, setIsImgUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [guardianData, setGuardianData] = useState([]);
  const [selectedGuardianData, setSelectedGuardianData] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [moreDetailsModal, setMoreDetails] = useState(false);
  const [changeDetailDialogOpen, setChangeDetailDialogOpen] = useState(false);
  const [districtAllowed, setDistrictAllowed] = useState(false);
  const [changeAcceptDetailDialogOpen, setChangeAcceptDetailDialogOpen] =
    useState(false);
  const [prevPhoneNumber, setPrevPhoneNumber] = useState("");
  const [updatedPhoneNumber, setUpdatedPhoneNumber] = useState("");
  const [isPhoneNumberUpdated, setIsPhoneNumberUpdated] = useState(false);
  const [enterOTPDialogOpen, setEnterOTPDialogOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const userLocalTimeZone = localStorage.getItem("Time-Zone") || momentTz.tz.guess();
  const [selectedUserTimeZone, setSelectedUserTimeZone] = useState(userLocalTimeZone);
  const { deedToast } = useDeedToast();

  useEffect(() => {
    fetchData();
    fetchGuardianData();
  }, []);

  useEffect(() => {
    handleDistrict(phone);
  }, [phone]);

  const fetchData = async () => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const response = await axios.get(url, config);
    setPatientData(response.data.data);
    setName(response.data.data?.name);
    setDob(response.data.data?.dob);
    setGender(response?.data?.data?.gender);
    setEmail(response?.data?.data?.User?.email);
    setDistrict(response.data.data?.district);
    setMedications(response.data.data?.longTermMedic);
    setAllergies(response.data.data?.allergies);
    setPhone(response.data.data.User?.phoneNumber);
    // setPhone(response.data.data.User?.phoneNumber);
    setPrevPhoneNumber(response.data.data.User?.phoneNumber);
    setAddress(response.data.data?.address);
    setProfilePic(response?.data?.data?.User?.profileImagePath);
    setProfilePicUrl(response?.data?.data?.User?.profileImagePath);
    setAnalytics(response?.data?.data?.PatientAnalytic);

    setLoading(false);
  };

  const fetchGuardianData = async () => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    // const response = await axios.get(urlGuardian,config);
    // if(response?.data?.data){
    //   setGuardianData(response?.data?.data);
    // }
  };

  const mapToOptions = (array = []) => {
    let arr = [];
    array.forEach((item) => {
      let obj = {};
      obj.label = item;
      obj.value = item;
      arr.push(obj);
    });
    return arr;
  };

  const arrayToString = (array = []) => {
    let valueStr = "";
    array.forEach((item) => {
      valueStr = valueStr + item + ",";
    });
    return valueStr;
  };

  const handleselectedName = () => {
    const data = [];
    data.push(patientName);
    setCount(count + 1);
    setSelectName((old) => [...old, data]);
    setAddPatientDialogOpen(false);
  };

  const handleAddPatientDialogOpen = (item) => {
    setAddPatientDialogOpen(true);
    setSelectedGuardianData(null);
    if (item) {
      setSelectedGuardianData(item);
    }
  };
  const handleAddPatientDialogClose = () => {
    setAddPatientDialogOpen(false);
  };
  const handleDeactivateDialogOpen = () => {
    setDeactivateDialogOpen(true);
  };
  const handleDeactivateDialogClose = () => {
    setDeactivateDialogOpen(false);
  };
  const handleRemoveFile = (ind) => {
    const list = [...selectName];
    list.splice(ind, 1);
    setSelectName(list);
    setCount(count - 1);
  };
  const validate = async () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      errors.email = "Invalid email address";
    }
    // const regex = /^(0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const sriLankanPhoneRegex =
      /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

    // if (!phone) {
    //   errors.phone = "Phone number is required";
    // } else {
    //   if (!sriLankanPhoneRegex.exec(phone)) {
    //     if (!internationalPhoneRegex.exec(phone)) {
    //       errors.phone = "Incorrect phone number. If your mobile number not a Sri Lankan number (Ex: 071XXXXXXX), Enter your mobile number with country code (Ex: +44XXXXXXXXXXX)";
    //     }
    //   }
    // }

    setErrors(errors);
    return errors;
  };

  const handleUsersTimeZone = async (newTimeZone) => {
    if (!newTimeZone?.value) {
      console.error("Invalid timezone:", newTimeZone);
      return;
    }

    const updatedTimeZone = newTimeZone.value;

    // Update localStorage
    localStorage.setItem("Time-Zone", updatedTimeZone);

    // Update state to reflect the change in the UI without a refresh
    setSelectedUserTimeZone(updatedTimeZone);

    // Call backend API to save user timezone in the database
    await saveUserTimeZone(updatedTimeZone);

  };

  const saveUserTimeZone = async (newtimeZone) => {
    let data = {
      userId: getUserId(),
      timeZone: newtimeZone,
    };
    // console.log("Time zone data : ", data);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}user/timezone/update`,
        data
      );
      // console.log("Backend response:", res.data);
      if (res?.data?.data?.isExisting) {
        // alert("Timezone updated successful!. Please refresh the browser to make changing effects");
        deedToast(
          "Your timezone is changed to "+ newtimeZone + ".",
          "success",
          "Timezone Updated Successfully!"
        );
        localStorage.setItem("Time-Zone", newtimeZone);

      } else {
        // console.log("User not found.");
        // alert("Failed to update time zone: User not found.");
        deedToast(
          "Failed to update time zone: User not found.",
          "danger",
          "Timezone Updated Failed!"
        );
      }

      return res?.data?.data;
    } catch (error) {
      // console.error("Error updating time zone:", error);
      // alert("Error updating time zone.");
      deedToast("Error updating time zone.", "danger", "Error!");
    }
  };

  const onSubmit = async () => {
    try {
      const validationErrors = await validate();
      // alert("Pass validations");
      if (Object.keys(validationErrors).length !== 0) {
        // alert("there is some errors");
        setLoading(false);
        return;
      }
      // isPhoneNumberUpdateCheck(prevPhoneNumber, updatedPhoneNumber);
      // if (isPhoneNumberUpdated === false) {
        // skip phone check entirely
try {
  const payload = {
    email: email,
    phoneNumber: phone, // still send current phone
    name: name,
    gender: gender,
    // district: districtAllowed ? district || "" : "",
    address: address,
    dob: dob,
    longTermMedic: medications,
    allergies: allergies,
  };
  let config = {
    headers: { Authorization: "Bearer " + getToken() },
  };
  // only include district if it's allowed and not empty
  if (districtAllowed && district) {
    payload.district = district;
  }
  
  const response = await axios.put(
    `${process.env.REACT_APP_BACKEND_URL}user/patient/profile`,
    payload,
    config
  );
  alert("Successfully updated");
  fetchData();
} catch (error) {
  console.error(error.response?.data.message || "Unexpected error");
  setErrors({ backend: error.response.data.message });
} finally {
  setLoading(false);
}
    
      
    } catch (error) {
      console.error(error.response?.data.message || "Unexpected error");
      // alert("phone number checked successfull");
      //
    }
  };

  const uploadPic = async (event) => {
    setIsImgUploading(true);
    if (event.target.files.length !== 0) {
      let selected = event.target.files;
      let currentFile = selected[0];
      setSelectedFiles(currentFile);

      const sinfile = new FormData();
      sinfile.append("file", currentFile);
      let config = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };

      await axios
        .post(ApiEndpoint.PROFILE_PIC_UPDATE, sinfile, config)
        .then((response) => {
          // alert("Successfully updated");
          fetchData();
        })
        .catch((error) => {
          // console.log(error.response.data.message);
          const errors = {};
          errors.backend = error.response.data.message;
          setErrors(errors);
          // alert("Something went wrong Please recheck your inputs!");
        });
    } else {
      setSelectedFiles(null);
    }
    setIsImgUploading(false);
  };

  const sendOTPsl = async (email, phone) => {
    let data = {
      email: email,
    };
    // should be both to email, and phone. if one of methods, doesn't exist, souldn't be sent OTP.
    if (phone) {
      data.phoneNumber = phone;
    }
    if (email) {
      data.email = email;
    }

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/send-otp/srilanka`,

      data
    );

    return res?.data?.data;
  };

  const sendOTPint = async (email) => {
    let data = {
      email: email,
    };
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/send-otp/international`,
      data
    );
    return res?.data?.data;
  };

  // const gotoOtp = async (email, updatedPhoneNumber) => {
  //   const data = {
  //     email: email,
  //     phoneNumber: updatedPhoneNumber,
  //   };

  //   const sriLankanPhoneRegex =
  //     /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

  //   const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

  //   if (sriLankanPhoneRegex.exec(updatedPhoneNumber)) {
  //     data.phoneNumber = updatedPhoneNumber;
  //     alert("OTP will be sent to your phone number and to the email.");
  //     try {
  //       const res = await sendOTPsl(email, updatedPhoneNumber);
  //       // alert(res);
  //       if (res) {
  //         // navigate("/otpScreen", { state: data });
  //         handleEnterOTPDialogOpen();
  //       } else {
  //         // alert("Something went wrong!");
  //       }
  //     } catch {
  //       // alert("Cannot done the change right now");
  //     }
  //   } else if (internationalPhoneRegex.exec(updatedPhoneNumber)) {
  //     alert("OTP will be sent to your email.");
  //     const res = await sendOTPint(email);
  //     // alert('int : ' + res);
  //     if (res) {
  //       // navigate("/otpScreen", { state: data });
  //       handleEnterOTPDialogOpen();
  //     } else {
  //       // alert("Something went wrong!");
  //     }
  //   } else {
  //     // alert("Sorry! Can not done the change right now");
  //   }
  // };

  // const checkPhoneNumber = (updatedPhoneNumber) => {
  //   const sriLankanPhoneRegex =
  //     /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

  //   const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;
  //   // alert('Phone number is checking...');
  //   if (sriLankanPhoneRegex.test(updatedPhoneNumber)) {
  //     gotoOtp(email, updatedPhoneNumber);
  //   } else if (internationalPhoneRegex.test(updatedPhoneNumber)) {
  //     gotoOtp(email, updatedPhoneNumber);
  //   } else {
  //   }
  // };

  // const isPhoneNumberUpdateCheck = (prevPhoneNumber, updatedPhoneNumber) => {
  //   if (!updatedPhoneNumber) {
  //     // alert('Phone number unchanged');
  //     return; // Early exit if updatedPhoneNumber is not provided.
  //   }
  //   if (prevPhoneNumber === updatedPhoneNumber) {
  //     setIsPhoneNumberUpdated(false);
  //     // alert('Phone number not updated');
  //   } else {
  //     // alert('Phone number is updated...');
  //     setIsPhoneNumberUpdated(true);
  //     // alert('Phone number set updated...');
  //     checkPhoneNumber(updatedPhoneNumber);
  //   }
  // };

  const handleChangeDetailDialogOpen = () => {
    setChangeDetailDialogOpen(true);
  };

  const handleChangeDetailDialogClose = () => {
    setChangeDetailDialogOpen(false);
  };

  const handleChangeAcceptDetailDialogOpen = () => {
    setChangeAcceptDetailDialogOpen(true);
  };

  const handleChangeAcceptDetailDialogClose = () => {
    setChangeAcceptDetailDialogOpen(false);
  };

  const handleEnterOTPDialogOpen = () => {
    setEnterOTPDialogOpen(true);
  };

  const handleEnterOTPDialogClose = () => {
    setEnterOTPDialogOpen(false);
  };

  const handleSubmitOTPValue = (otp) => {
    setOtpValue(otp); // Update OTP value in parent state
    // console.log('OTP submitted:', otp);
    handleOTPsubmit(otp);
  };


  const customStyles = {
    container: (provided) => ({
      ...provided,
      // width: "300px",
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: "#f5f5f5", // Background color
      borderColor: "#ccc", // Border color
      borderRadius: "8px",
      padding: "1px",
      cursor: "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "white", // Focus color
      color: "#333", // Text color
      padding: "5px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333", // Selected value color
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#999", // Change dropdown icon color
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the separator line
    }),
  };

  const handleOTPsubmit = async (otp) => {
    try {
      setLoading(true);
      const sriLankanPhoneRegex =
        /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

      const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

      const validationErrors = await validate();
      if (Object.keys(validationErrors).length !== 0) {
        setLoading(false);

        return;
      }

      const payload = {
        email: email,
        otp,
        phoneNumber: updatedPhoneNumber,
        name: name,
        gender: gender,
        district: district,
        address: address,
        dob: dob,
        longTermMedic: medications,
        allergies: allergies,
        // bankName: bankName,
        // bankBranch: branch,
        // bankAccountNumber: accountNum,
        // // consultationFee: "4",
        // // displayingFee: "5"
      };

      // console.log('Payload : ', payload);

      let config = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };

      if (sriLankanPhoneRegex.test(payload.phoneNumber)) {
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}user/patient/profile/sl`,
          payload,
          config
        );
        alert("Successfully updated");
        fetchData();
        handleEnterOTPDialogClose();
      } else if (internationalPhoneRegex.test(payload.phoneNumber)) {
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}user/patient/profile/international`,
          payload,
          config
        );
        alert("Successfully updated");
        fetchData();
        setLoading(false);
        handleEnterOTPDialogClose();
      } else {
        // alert("Update failed. Incorrect phone number");
        setLoading(false);
      }
    } catch (error) {
      console.error(error.response?.data.message || "Unexpected error");
      setErrors({ backend: error.response.data.message });
    } finally {
      setLoading(false);
    }
  };

  const handleDistrict = (phoneNumber) => {
    const sriLankanPhoneRegex =
      /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

    if (phoneNumber) {
      if (sriLankanPhoneRegex.test(phoneNumber)) {
        setDistrictAllowed(true);
      } else if (internationalPhoneRegex.test(phoneNumber)) {
        setDistrictAllowed(false);
      } else {
        setDistrictAllowed(false);
      }
    } else {
      setDistrictAllowed(false);
    }
  };

  if (loading) {
    return (
      <center style={{ marginTop: 200 }}>
        <CircularProgress />
      </center>
    );
  }


  return (
    // Edit Dialog
    <>
      {/* MorePatientModal Dialog */}
      <MorePatientModal
        open={moreDetailsModal}
        handleOk={undefined}
        handleCancel={() => setMoreDetails(false)}
      />
      {/* Deactivate Dialog */}
      <DeactivateModal
        open={deactivateDialogOpen}
        handleOk={undefined}
        handleCancel={handleDeactivateDialogClose}
      />
      {/* add patient dialog */}
      {/* change details dialog */}
      <ChangeDetailModal open={changeDetailDialogOpen} handleOk={undefined} />
      <ChangeAcceptDetailModal
        open={changeAcceptDetailDialogOpen}
        handleOk={undefined}
        handleCancel={handleChangeAcceptDetailDialogClose}
      />
      <EnterOTPModal
        open={enterOTPDialogOpen}
        handleCancel={handleEnterOTPDialogClose}
        handleSubmit={handleSubmitOTPValue}
      />

      <div>
        <AddPatientDialog
          // onClose={handleEditDialogClose}
          aria-labelledby="customized-dialog-title"
          open={addPatientDialogOpen}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogContent className="selectTimeDialogContent">
            <AddGuardianModal
              handleAddPatientDialogClose={handleAddPatientDialogClose}
              data={selectedGuardianData}
              handleRefresh={() => {
                fetchData();
                fetchGuardianData();
              }}
            />
          </DialogContent>
        </AddPatientDialog>
      </div>

      <div className="profileMain">
        <div className="profileHeading">
          <h3>My Profile</h3>
        </div>
        <div>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 2,
                pb: 2,
                pr: 2,
                width: "100%",
                height: "auto",
                background:
                  "linear-gradient(90.22deg, #0536E3 -19.45%, #00E9ED 142.36%)",
                color: "#ffffff",
              },
            }}
          >
            <Paper elevation={0}>
              <Grid container className="profileNameGrid">
                <Grid item lg={7} md={4} xs={12}>
                  <Stack direction="row" spacing={0}>
                    {isImgUploading ? (
                      <div className="loadingProfile">
                        <CircularProgress />
                      </div>
                    ) : (
                      <Avatar
                        alt="Patient Avatar"
                        src={
                          profilePic !== null ? profilePicUrl : patientAvatar
                        }
                        className="pateintProfileAvatar"
                      />
                    )}
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                      className="patientProfileAvatarButton"
                    >
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => uploadPic(e)}
                      />
                      <PhotoCamera className="patientProfileCameraButton" />
                    </IconButton>
                    <div style={{ padding: "5px 5px" }}>
                      <div className="profileAvatarName">
                        <h2>{patientData && patientData?.name}</h2>
                        <p className="textCapitalization">
                          {patientData && patientData?.User?.userType}
                        </p>
                      </div>
                    </div>
                  </Stack>
                </Grid>

                <Grid item lg={5} md={8} xs={12} className="profileStatusGrid">
                  <Grid item lg={1} md={2} xs={3}>
                    <div className="profileAppointments">
                      <div>
                        <h4>
                          {analytics?.appointmentCount
                            ? analytics?.appointmentCount
                            : 0}
                        </h4>
                        <p>Appointments</p>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={1} md={2} xs={3}>
                    <div className="profileAppointments">
                      <div>
                        <h4>
                          {analytics?.reviewCount ? analytics?.reviewCount : 0}
                        </h4>
                        <p>Reviews</p>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={1} md={2} xs={3}>
                    <div className="profileAppointments">
                      <div>
                        <h4>
                          {analytics?.reportReadingCount
                            ? analytics?.reportReadingCount
                            : 0}
                        </h4>
                        <p>Report Reading</p>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={1} md={2} xs={3}>
                    <div className="profileAppointments">
                      <div>
                        <h4>
                          {analytics?.consultingCount
                            ? analytics?.consultingCount
                            : 0}
                        </h4>
                        <p>Consulting</p>
                      </div>
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sx={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Grid item lg={5} md={8} xs={12}>
                    <div
                      style={{
                        // width: "50%",
                        paddingLeft: 10,
                        paddingRight: 10,
                        display: "flex",
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        borderColor: "white",
                        borderStyle: "solid",
                        borderWidth: 0.5,
                        backgroundColor: "transparent",
                        borderRadius: 5,
                      }}
                    >
                      <div style={{ marginRight: 4 }}>
                        <p>Your Time Zone : </p>
                      </div>
                      {/* Time-zone select drop down here */}
                      <div>
                        <TimezoneSelect
                          value={selectedUserTimeZone}
                          onChange={handleUsersTimeZone} // Directly passing function
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </div>

        <div className="docterProfileScroll">
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 2,
                pb: 2,
                pr: 2,
                width: "100%",
                height: "auto",
              },
            }}
          >
            <Paper elevation={0}>
              <h4>Personal Information</h4>
              <Grid container className="personalInfoGrid1">
                <Grid item lg={8} md={8} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} xs={12}>
                      <div className="infoCol1">
                        {/* Column 1 */}

                        <Grid item lg={4} md={4} xs={12}>
                          <div className="info1">
                            <div>
                              <h6>Name</h6>
                              <p>{name}</p>
                            </div>
                          </div>
                          <div className="info2">
                            <DefaultTextInput
                              type="date"
                              title="Date of Birth"
                              editableText={true}
                              value={dob?.split("T")[0]}
                              placeholder={"Email"}
                              onChangeValue={(v) => {
                                setDob(v.target.value);
                              }}
                              onEditClick={(e) => e && setIsEditable(true)}
                            />
                          </div>
                          <div className="info2">
                            {/* <DefaultTextInput
                              title="Phone"
                              editableText={true}
                              value={phone}
                              placeholder={"Phone"}
                              onChangeValue={(v) => {
                                setPhone(v.target.value);
                                setUpdatedPhoneNumber(v.target.value);
                              }}
                              onEditClick={(e) => {
                                e && setIsEditable(true);
                                e && handleChangeAcceptDetailDialogOpen();
                              }}
                            /> */}
                            <DefaultTextInput
                              title="Phone"
                              editableText={false} // prevents the pencil icon edit trigger
                              value={phone}
                              placeholder={"Phone"}
                              disabled={true} // visually disables typing
                            />
                          </div>
                        </Grid>

                        {/* Column 2 */}

                        <Grid item lg={4} md={4} xs={12}>
                          <div className=" selectInfo">
                            <EditableSelect
                              selected={gender}
                              options={["Male", "Female"]}
                              title="Gender"
                              editableText={true}
                              value={gender}
                              placeholder="Gender"
                              onEditClick={(e) => e && setIsEditable(true)}
                              onChangeValue={(v) => {
                                setGender(v.target.value);
                              }}
                            />
                          </div>
                          <div className=" info2">
                            <DefaultTextInput
                              title="Email"
                              editableText={true}
                              value={email}
                              placeholder={"Email"}
                              // onChangeValue={(v) => {
                              //   setEmail(v.target.value);
                              // }}
                              onEditClick={(e) => {
                                e && setIsEditable(true);
                                handleChangeDetailDialogOpen();
                              }}
                            />
                          </div>
                          <div className="info2">
                            <EditableMultiSelect
                              options={mapToOptions(longTermMedicationsArr)}
                              title="Long term medications currently having"
                              editableText={true}
                              value={mapToOptions(medications)}
                              placeholder={arrayToString(medications)}
                              onChangeValue={(v) => {
                                setMedications(v);
                              }}
                              onEditClick={(e) => e && setIsEditable(true)}
                            />
                          </div>
                        </Grid>

                        {/* Column 3 */}

                        <Grid item lg={4} md={4} xs={12}>
                          <div className="">
                            <DefaultTextInput
                              title="Address"
                              editableText={true}
                              value={address}
                              placeholder={"Address"}
                              onChangeValue={(v) => {
                                setAddress(v.target.value);
                              }}
                              onEditClick={(e) => e && setIsEditable(true)}
                            />
                          </div>
                          {districtAllowed === true && (
                            <div className=" info2">
                              <EditableSelect
                                selected={district || ""}
                                options={districts}
                                title="District"
                                editableText={true}
                                value={district || ""}
                                placeholder="District"
                                onEditClick={(e) => e && setIsEditable(true)}
                                onChangeValue={(v) => {
                                  setDistrict(v.target.value);
                                }}
                              />
                            </div>
                          )}
                          <div className="info2">
                            <EditableMultiSelect
                              options={mapToOptions(allergiesArr)}
                              title="Allergies"
                              editableText={true}
                              value={mapToOptions(allergies)}
                              placeholder={arrayToString(allergies)}
                              onChangeValue={(v) => {
                                setAllergies(v);
                                // setAllergiesArr(v);
                              }}
                              onEditClick={(e) => e && setIsEditable(true)}
                            />
                          </div>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Map */}

                <Grid item lg={4} md={4} xs={12}>
                  {/* <div className="googleMapDiv">
                    <img
                      alt="google map img"
                      src="https://i.stack.imgur.com/HILmr.png"
                      width={250}
                    />
                    <p>Set Your Location {">>"}</p>
                  </div> */}
                </Grid>
              </Grid>
              {/* Add more patients Details */}
              {patientData && patientData?.User?.userType !== "PATIENT" ? (
                <>
                  <div className="addMorePatients">
                    <h4>Add More Patients</h4>
                    <p>can add 3 patient profiles for free</p>
                    <p>
                      Additional cost will be charged for each and every
                      additional profiles
                    </p>
                  </div>

                  <Grid container className="personalInfoGrid1">
                    <Grid item lg={12} md={12} xs={12}>
                      <div className="addMorePatientsDetails">
                        {guardianData &&
                          Array.isArray(guardianData) &&
                          guardianData.map((item, ind) => {
                            return (
                              <Grid item lg={3} md={3} xs={12}>
                                <div className="addMoreDetailinfo" key={ind}>
                                  <div>
                                    <Stack direction="row" spacing={2}>
                                      <Avatar
                                        alt="Patient Avatar"
                                        src={patientAvatar}
                                        className="addMorePatientsAvatar"
                                      />
                                      <div className="addMorePatientAvatarName">
                                        <h5>{item.name}</h5>
                                        <p>Patient</p>
                                      </div>
                                    </Stack>
                                    <div className="editIcon deleteIcon">
                                      <img
                                        src={editIcon2}
                                        alt="edit icon"
                                        width={20}
                                        onClick={() => {
                                          handleAddPatientDialogOpen(item);
                                        }}
                                      />
                                      <img
                                        src={deleteIcon}
                                        alt="delete icon"
                                        width={20}
                                        onClick={() => {
                                          handleRemoveFile(ind);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            );
                          })}
                      </div>
                      <Button
                        variant="text"
                        className="addMorePatientBtn"
                        onClick={() => {
                          if (guardianData.length > 3) {
                            setMoreDetails(true);
                          } else {
                            handleAddPatientDialogOpen();
                          }
                        }}
                      >
                        Add more
                        <span>
                          <AddCircleIcon />
                        </span>
                      </Button>
                    </Grid>
                  </Grid>
                </>
              ) : null}
              <ErrorDisplay errors={errors} />
              <div>
                <Button
                  variant="outlined"
                  className="deactivateBtn"
                  onClick={handleDeactivateDialogOpen}
                >
                  Deactivate Profile
                </Button>
                {isEditable ? (
                  <Button
                    style={{ marginLeft: "10px" }}
                    variant="outlined"
                    className="saveBtn"
                    onClick={onSubmit}
                  >
                    Save Profile
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </Paper>
          </Box>
        </div>
      </div>
    </>
  );
};
export default PatientProfile;
